import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Set up a base Axios instance
const apiClient = axios.create({
  baseURL: API_URL + "/api/v1", // optional
  headers: {
    "Content-Type": "application/json",
  },
});

// Generic API caller
const callApi = async ({ url, method = "GET", params = {}, data = {} , headers = {}}) => {
  try {
    const response = await apiClient({
      url,
      method,
      params,
      data,
      headers,
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export default callApi
